import { api, ApiError } from './api';

export interface CategoryResponse {
  id: number;
  name: string;
  createdAt: string;
  updatedAt: string;
}

export const categories = {
  getAll: async (): Promise<CategoryResponse[]> => {
    try {
      const response = await api.get<CategoryResponse[]>('/categories');
      return response;
    } catch (error) {
      const apiError = error as ApiError;
      throw apiError;
    }
  },
};

export const merchCategories = {
  getAll: async (): Promise<CategoryResponse[]> => {
    try {
      const response = await api.get<CategoryResponse[]>('/merch-categories');
      return response;
    } catch (error) {
      const apiError = error as ApiError;
      throw apiError;
    }
  },
};
